import { Flex, Text, Heading, Divider } from '@customerio/pluma-components/react';
import type { SearchResult } from '@/services/auth/types';
import { isEmptyString } from '@/utils/string';
import { CampaignPreview } from './campaign-preview';
import { SegmentPreview } from './segment-preview';
import { TemplatePreview } from './template-preview';
import { ActionPreview } from './action-preview';
import { NewsletterPreview } from './newsletter-preview';
import { CustomerPreview } from './customer-preview';

function PreviewContent({ result }: { result: SearchResult }): React.JSX.Element | null {
  switch (result.kind) {
    case 'campaign':
      return <CampaignPreview result={result} />;
    case 'segment':
      return <SegmentPreview result={result} />;
    case 'template':
      return <TemplatePreview result={result} />;
    case 'action':
      return <ActionPreview result={result} />;
    case 'newsletter':
      return <NewsletterPreview result={result} />;
    case 'customer':
      return <CustomerPreview result={result} />;
    case 'navigation':
      return null;
  }
}

function getDescription(result: SearchResult): { show: true; value?: string } | { show: false } {
  if (result.kind === 'campaign' || result.kind === 'segment') {
    return { show: true, value: result.other.description };
  }
  return { show: false };
}

export function QuickLookPanel({ result }: { result: SearchResult | null }) {
  if (result == null || result.kind === 'navigation') {
    return (
      <Flex direction="column" alignItems="center" justifyContent="center" w="full" h="full" p="200">
        <Text size="xs" color="subtle">
          No preview
        </Text>
      </Flex>
    );
  }

  const description = getDescription(result);

  return (
    <Flex direction="column" gap="200" w="full" h="full" overflow="auto" p="200">
      <Flex direction="column" gap="050">
        <Heading level="2" className="fs-mask">
          {result.title}
        </Heading>
        {description.show ? (
          <Text
            size="xs"
            color={isEmptyString(description.value) ? 'placeholder' : 'subtle'}
            className={!isEmptyString(description.value) ? 'fs-mask' : undefined}
          >
            {!isEmptyString(description.value) ? description.value : '—'}
          </Text>
        ) : null}
      </Flex>

      <Divider />

      <Flex direction="column" gap="100" w="full" alignItems="stretch">
        <PreviewContent result={result} />
      </Flex>
    </Flex>
  );
}
